/**
 * Navigation Bar Service
 * Controls Android system navigation bar color using @capgo/capacitor-navigation-bar
 */

import { NavigationBar } from '@capgo/capacitor-navigation-bar';
import { isNativeAndroid } from '../utils/platform.utils';

export const navigationBarService = {
  /**
   * Set navigation bar to black with light (white) icons
   * Called on app startup to ensure consistent dark theme
   */
  async setDarkTheme(): Promise<void> {
    if (!isNativeAndroid()) {
      return;
    }

    try {
      // Set navigation bar background to black with light (white) buttons
      // darkButtons: false = light/white icons on dark background
      await NavigationBar.setNavigationBarColor({
        color: '#000000',
        darkButtons: false
      });
      console.log('[NavigationBar] Set to black with white icons');
    } catch (error) {
      console.error('[NavigationBar] Failed to set color:', error);
    }
  },

  /**
   * Get current navigation bar color
   */
  async getColor(): Promise<string | null> {
    if (!isNativeAndroid()) {
      return null;
    }

    try {
      const result = await NavigationBar.getNavigationBarColor();
      return result.color;
    } catch (error) {
      console.error('[NavigationBar] Failed to get color:', error);
      return null;
    }
  }
};
